if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activateTab(index));
        });
      }

      activateTab(index) {
        this.tabs.forEach((tab, i) => {
          const isActive = i === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel, i) => {
          const isActive = i === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        const activeTab = this.tabs[index];
        if (activeTab) {
          activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
    }
  );
}
